import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ccyPairActions from './reducer';
import CcyList from './CcyList';
import CurrencyPairsList from './CurrencyPairsList';
import './CurrencyPair.css';


class CurrencyPairAdminComponent extends Component {
  static get propTypes() {
    return {
      fetchingCcys: PropTypes.bool,
      fetchingPairs: PropTypes.bool,
      currencies: PropTypes.array,
      currencyPairs: PropTypes.array,
      fetchCurrencyData: PropTypes.func.isRequired,
      removeCurrencyPair: PropTypes.func.isRequired,
      selectCcy1: PropTypes.func.isRequired,
      selectCcy2: PropTypes.func.isRequired,
      addCurrencyPair: PropTypes.func.isRequired,
      ccy1: PropTypes.string,
      ccy2: PropTypes.string,

    };
  }

  constructor(props) {
    super(props);
    props.fetchCurrencyData();
  }

  onRemoveCcyPair(ccyPair) {
    if (!window.confirm(`Are you sure you want to delete ${ccyPair}`)) {
      return;
    }
    const { removeCurrencyPair } = this.props;
    const ccyPairArray = ccyPair.split('/');
    removeCurrencyPair(ccyPairArray[0], ccyPairArray[1]);
  }

  render() {
    const { fetchingCcys, fetchingPairs } = this.props;
    return (
      <div className="CurrencyPair">
        <div className="CurrencyPair-PairsList">
          {fetchingPairs === true && <span>Fetching Currency Pairs...</span>}
          {fetchingPairs === false && this.renderCurrencyPairs()}
        </div>

        {fetchingCcys === true && <span>Fetching Currencies...</span>}
        {fetchingCcys === false && this.renderCurrencies()}
      </div>
    );
  }

  renderCurrencies() {
    const { currencies, selectCcy1, selectCcy2, currencyPairs, addCurrencyPair } = this.props;
    const { ccy1, ccy2 } = this.props;

    if (currencies === undefined) return null;
    const blankCCy = !ccy1 || !ccy2;
    const sameCcy = !blankCCy && ccy1 === ccy2;
    const pairExists = !blankCCy && currencyPairs.filter(cp => cp === `${ccy1}/${ccy2}`).length > 0;
    const disableAdd = blankCCy || sameCcy || pairExists;

    let warningText = '';
    if (sameCcy) {
      warningText = 'Same ccys';
    } else if (pairExists) {
      warningText = 'Ccy pair exists';
    }
    return (
      <div className="CurrencyPair-Ccys">
        <div className="CurrencyPair-Ccys-Group">
          <div className="CurrencyPair-Ccys-Group-Header">Currency 1</div>
          <CcyList name="ccy1" placeholder="Ccy 1" value={ccy1} currencies={currencies} onSelectCcy={selectCcy1} />
        </div>
        <div className="CurrencyPair-Ccys-Group">
          <div className="CurrencyPair-Ccys-Group-Header">Currency 2 </div>
          <CcyList name="ccy2" placeholder="Ccy 2" value={ccy2} currencies={currencies} onSelectCcy={selectCcy2} />
        </div>
        <div className="CurrencyPair-Ccys-Group">
          <div className="CurrencyPair-Ccys-Group-Header CurrencyPair-Ccys-warning">{warningText}&nbsp; </div>
          <input className="CurrencyPair-Ccys-Group-addbutton btn btn-submit" type="buton" value="Add" disabled={disableAdd} onClick={() => addCurrencyPair(ccy1, ccy2)} />
        </div>
      </div>
    );
  }

  renderCurrencyPairs() {
    const { currencyPairs } = this.props;
    if (currencyPairs === undefined) return null;
    return (
      <div>
        <CurrencyPairsList currencyPairs={currencyPairs} onRemove={p => this.onRemoveCcyPair(p)} />
      </div>
    );
  }
}


function mapStateToProps(state) {
  const { ccy1, ccy2 } = state.admin.ccyInfo;
  return {
    fetchingCcys: state.admin.ccyInfo.fetchingCcys,
    currencies: state.admin.ccyInfo.currencies,
    fetchingPairs: state.admin.ccyInfo.fetchingCcyPairs,
    currencyPairs: state.admin.ccyInfo.currencyPairs,
    ccy1,
    ccy2
  };
}

function mapDispatchToProps(dispatch) {
  const { fetchCurrencyPairDataIfNeeded,
    fetchCurrencyPairs,
    selectCcy1,
    selectCcy2,
    addCurrencyPair,
    removeCurrencyPair } = bindActionCreators(ccyPairActions, dispatch);

  return {
    fetchCurrencyData: fetchCurrencyPairDataIfNeeded,
    fetchCurrencyPairs,
    selectCcy1,
    selectCcy2,
    addCurrencyPair,
    removeCurrencyPair
  };
}
const CurrencyPairAdmin = connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrencyPairAdminComponent);
export default CurrencyPairAdmin;



// WEBPACK FOOTER //
// ./src/admin/currencyPairs/CurrencyPair.js